export default __webpack_public_path__ + "static/media/BUYING 1.fd3cf1d0.png";